module.exports = __webpack_public_path__ + "static/media/hand.bab44a78.png";